import { request, getToken, setToken } from './client'

export function isAuthed () {
  return !!getToken()
}

export async function login (username, password) {
  const data = await request('/auth/login', {
    method: 'POST',
    body: { username, password },
    token: null
  })
  if (data?.token) setToken(data.token)
  return data
}

export async function logout () {
  try {
    await request('/auth/logout', { method: 'POST' })
  } catch {
    // ignore network errors — clear the token regardless
  }
  setToken(null)
}

export async function me () {
  return request('/auth/me')
}
